var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokelau(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4541C24.8366 32.4541 32 25.2907 32 16.4541C32 7.61755 24.8366 0.454102 16 0.454102C7.16344 0.454102 0 7.61755 0 16.4541C0 25.2907 7.16344 32.4541 16 32.4541Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7391 8.10629C25.5956 8.79598 25.5304 9.53054 25.5304 10.2628C25.5304 14.4837 28.0466 18.1369 31.6526 19.7814C31.8796 18.7079 32 17.5951 32 16.4541C32 7.6176 24.8365 0.454102 16 0.454102C7.1635 0.454102 0 7.6176 0 16.4541C0 25.2906 7.1635 32.4541 16 32.4541C21.4801 32.4541 26.3161 29.6984 29.1998 25.4976H9.0435V23.4107H30.4124C30.6311 22.9584 30.8286 22.4941 31.0049 22.0194H9.0435L25.7391 8.10629Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7535 8.80151L12.0988 9.86439H13.2163L12.3123 10.5213L12.6577 11.5841L11.7535 10.9273L10.8494 11.5841L11.1947 10.5213L10.2905 9.86439H11.4081L11.7535 8.80151Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2143 16.4541L7.64605 17.7828H9.04293L7.91274 18.6037L8.34449 19.9324L7.2143 19.1112L6.08418 19.9324L6.51587 18.6037L5.38574 17.7828H6.78262L7.2143 16.4541Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2143 5.32359L7.64605 6.65227H9.04293L7.91274 7.47321L8.34449 8.80183L7.2143 7.9807L6.08418 8.80183L6.51587 7.47321L5.38574 6.65227H6.78262L7.2143 5.32359Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.73628 11.5846L4.16803 12.9133H5.56484L4.43471 13.7343L4.86647 15.0629L3.73628 14.2417L2.60615 15.0629L3.03784 13.7343L1.90771 12.9133H3.30453L3.73628 11.5846Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokelau);
export default __webpack_public_path__ + "static/media/tokelau.20583afd.svg";
export { ForwardRef as ReactComponent };